import { Deserializable } from '../protocols/deserializable';
import { SelfEnrolmentLogo } from './self-enrolment-logo';

export class EpSelfEnrolmentResponse implements Deserializable {
  public employerLogo: SelfEnrolmentLogo | null = null;
  public submissionLogo: SelfEnrolmentLogo | null = null;

  onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    if (this.employerLogo) {
      this.employerLogo = Deserialize?.instanceOf(SelfEnrolmentLogo, this.employerLogo) ?? null;
    }
    if (this.submissionLogo) {
      this.submissionLogo = Deserialize?.instanceOf(SelfEnrolmentLogo, this.submissionLogo) ?? null;
    }
  }
}
